<template>
  <!-- <div :class="$style['report-user-message']"> -->
  <table cellspacing="0" border="1" :class="$style['report-user-message']">
    <tr class="first-line">
      <td>委托方（甲方）</td>
      <td>承检方（乙方）</td>
    </tr>
    <tr>
      <td>单位名称：{{ partyAInformation.companyName }}</td>
      <td>单位名称：{{ partyBInformation.companyName }}</td>
    </tr>
    <tr>
      <td>通讯地址（邮政编码）：{{ partyAInformation.address }}</td>
      <td>通讯地址（邮政编码）：{{ partyBInformation.address }}</td>
    </tr>
    <tr>
      <td>
        <div>联系人：{{ partyAInformation.contactName }}</div>
        <div>联系电话：{{ partyAInformation.phone }}</div>
        <div>
          <span>E-mail：{{ partyAInformation.email }}</span>
        </div>
      </td>
      <td>
        <div>联系人：{{ partyBInformation.contactName }}</div>
        <div>联系电话：{{ partyBInformation.phone }}</div>
        <div>
          <span>E-mail：{{ partyBInformation.email }}</span>
          <span class="qq">QQ：{{ partyBInformation.qq }}</span>
        </div>
      </td>
    </tr>
  </table>
  <!-- </div> -->
</template>
<script>
export default {
  props: {
    partyAInformation: Object,
    partyBInformation: Object,
  },
};
</script>
<style module lang="less">
.report-user-message {
  // table {
  width: 100%;
  border-spacing: 0;
  td {
    padding: 10px;
    width: 50%;
    text-align: left;
    :global {
      .qq {
        padding-left: 10px;
      }
    }
  }
  :global {
    .first-line {
      td {
        text-align: center;
      }
    }
  }
  // }
}
</style>
